import { CSSProperties } from "react";
import { ReactNode } from "react";

import { cx, styled } from "simplydo/react/styled";

type LabelContentProps = {
  children?: ReactNode;
  style?: CSSProperties;
  className?: string;
};

const StyledLabelContent = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LabelContentComponent = ({
  children,
  className,
  ...rest
}: LabelContentProps) => {
  return (
    <StyledLabelContent className={cx(className)} {...rest}>
      {children}
    </StyledLabelContent>
  );
};

export const LabelContent = styled(LabelContentComponent)``;
